import React, { useEffect, useState } from 'react';
import styles from './ConditionNode.module.scss';
import NodeContainer from '../node-container/NodeContainer';
import { Handle, Position, useNodes } from '@xyflow/react';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import ConditionModal from './condition-modal/ConditionModal';
import { variableManagement } from 'hooks/endpoints';
import { useFetch } from 'hooks/useFetch';

const isData = [
  { value: 1, label: 'is' },
  { value: 2, label: 'is not' },
  { value: 3, label: 'greater than' },
  { value: 4, label: 'greater or equal' },
  { value: 5, label: 'less than' },
];

const ConditionNode = ({ id, selected, ...props }) => {
  const nodes = useNodes();
  const node = nodes.find((node) => node.id === id);

  const [isError, setIsError] = useState(node?.is_Error || false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { data: apiData } = useFetch(
    ['variableManagement'],
    variableManagement.get,
    { enabled: true },
    { pageSize: 1000, pageNumber: 1 }
  );

  const isAnyElseIfBlockEmpty = node?.workFlowNode_Condition?.elseBlock?.some(
    (item) => item.value.trim() === '' || !item.operationId
  );
  const isIfEmpty = node?.workFlowNode_Condition?.ifBlock?.value.trim() === '';
  const isVariableEmpty = !node?.workFlowNode_Condition?.variableId;

  useEffect(() => {
    if (node?.workFlowNode_Condition) {
      if (isAnyElseIfBlockEmpty || isIfEmpty || isVariableEmpty) {
        setIsError(true);
      } else {
        setIsError(false);
      }
    } else {
      setIsError(node?.is_Error || true);
    }
  }, [
    node?.workFlowNode_Condition,
    isAnyElseIfBlockEmpty,
    isIfEmpty,
    isVariableEmpty,
  ]);
  return (
    <>
      <NodeContainer
        title="Condition Block"
        id={id}
        name={node?.title ?? 'Condition Block'}
        backgroundColor={node?.color}
        onClick={() => setIsModalOpen(true)}
        selected={selected}
        node={node}
        isError={isError}
      >
        <Handle
          type="target"
          position={Position.Left}
          className="custom-handle"
        />
        <div className={styles.cont}>
          {node?.workFlowNode_Condition == undefined ||
          !node?.workFlowNode_Condition?.ifBlock?.value ||
          !node?.workFlowNode_Condition?.variableId ? (
            <>
              <div className={styles.details}>
                <SvgWithBranding type="node-if" color="#787878" />
                <p className={styles.placeholder}>Add Conditional Path</p>
              </div>
            </>
          ) : (
            <>
              <>
                <div className={styles.details}>
                  <SvgWithBranding type="node-if" color="#787878" />
                  <p>{node?.workFlowNode_Condition?.ifBlock?.value}</p>
                  <Handle
                    type="source"
                    position={Position.Right}
                    className="custom-handle"
                    sourceHandle={`${id}-0`}
                    id={`${id}-0`}
                    style={{ position: 'absolute', left: '100%', top: '50%' }}
                  />
                </div>
                {node?.workFlowNode_Condition?.elseBlock?.length > 0 &&
                  node?.workFlowNode_Condition?.elseBlock?.map((item) => {
                    return (
                      <div className={styles.details}>
                        <p>{item?.value || '{value}'}</p>
                        <Handle
                          position={Position.Right}
                          type="source"
                          className="custom-handle"
                          sourceHandle={item.sourceHandle}
                          id={item.sourceHandle}
                          style={{
                            position: 'absolute',
                            left: '100%',
                            top: '70%',
                          }}
                        />
                      </div>
                    );
                  })}

                {node?.workFlowNode_Condition.reassessIntent === false
                  ? node?.workFlowNode_Condition.allOtherConditions
                      .isAllConditions && (
                      <div className={styles.details}>
                        <p>All Other Conditions</p>
                        <Handle
                          position={Position.Right}
                          type="source"
                          className="custom-handle"
                          sourceHandle={`${id}-1`}
                          id={`${id}-1`}
                          style={{
                            position: 'absolute',
                            left: '100%',
                            top: '70%',
                          }}
                        />
                      </div>
                    )
                  : null}
              </>
            </>
          )}
        </div>
      </NodeContainer>

      <ConditionModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        id={id}
        title="Condition"
        variableData={apiData}
        isError={isError}
      />
    </>
  );
};

export default ConditionNode;
